/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Active_StoriesInputs */

const en_seller_dashboard_active_stories = /** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Stories`)
};

const es_seller_dashboard_active_stories = /** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historias Activas`)
};

const fr_seller_dashboard_active_stories = /** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories actives`)
};

const de_seller_dashboard_active_stories = /** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Stories`)
};

const id_seller_dashboard_active_stories = /** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerita Aktif`)
};

/** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */
const ja_seller_dashboard_active_stories = en_seller_dashboard_active_stories;

/** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */
const zh_seller_dashboard_active_stories = en_seller_dashboard_active_stories;

/** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */
const ar_seller_dashboard_active_stories = en_seller_dashboard_active_stories;

/** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */
const it_seller_dashboard_active_stories = en_seller_dashboard_active_stories;

/** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */
const ru_seller_dashboard_active_stories = en_seller_dashboard_active_stories;

/** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */
const pt_seller_dashboard_active_stories = en_seller_dashboard_active_stories;

/** @type {(inputs: Seller_Dashboard_Active_StoriesInputs) => LocalizedString} */
const ko_seller_dashboard_active_stories = en_seller_dashboard_active_stories;

/**
* | output |
* | --- |
* | "Active Stories" |
*
* @param {Seller_Dashboard_Active_StoriesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_active_stories = /** @type {((inputs?: Seller_Dashboard_Active_StoriesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Active_StoriesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_active_stories(inputs)
	if (locale === "es") return es_seller_dashboard_active_stories(inputs)
	if (locale === "fr") return fr_seller_dashboard_active_stories(inputs)
	if (locale === "de") return de_seller_dashboard_active_stories(inputs)
	if (locale === "ja") return ja_seller_dashboard_active_stories(inputs)
	if (locale === "zh") return zh_seller_dashboard_active_stories(inputs)
	if (locale === "ar") return ar_seller_dashboard_active_stories(inputs)
	if (locale === "id") return id_seller_dashboard_active_stories(inputs)
	if (locale === "it") return it_seller_dashboard_active_stories(inputs)
	if (locale === "ru") return ru_seller_dashboard_active_stories(inputs)
	if (locale === "pt") return pt_seller_dashboard_active_stories(inputs)
	return ko_seller_dashboard_active_stories(inputs)
});